import { getProjectLookerUrlDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const getProjectLookerUrlCallable = getCallable(
  getProjectLookerUrlDefinition,
);
